// extracted by mini-css-extract-plugin
export default {"wrap":"Vt-z","melodyCategory":"Wt-z","fullWidth":"Xt-z","items":"Yt-z","featureCss":"Zt-z","disabled":"_t-z","imgCss":"au-z"};